"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("./axios");
exports.Axios = axios_1.Axios;
exports.default = axios_1.Axios;
